@if (isActive) {
  <div class="MobileActionsModal" @fadeToMaskOpacity>
    <div class="MobileActionsModal__Content">
      <div class="MobileActionsModal__ButtonsContainer">
        @for (action of actions; track action; let i = $index) {
          <ds-link
            [linkConfig]="action"
            (linkClicked)="handleLinkClicked($event)"
            [externalSiteModalConfig]="externalSiteModalConfig"
            class="MobileActionsModal__LinkHolder"
          >
            <div
              class="MobileActionsModal__Link"
              [ngClass]="{
                'MobileActionsModal__Link--NoBorderRadiusBottomLeft':
                  hideBottomBorders(i),
                'MobileActionsModal__Link--NoBorderRadiusBottomRight':
                  hideBottomBorders(i),
                'MobileActionsModal__Link--NoBorderRadiusTopLeft':
                  hideTopBorders(i),
                'MobileActionsModal__Link--NoBorderRadiusTopRight':
                  hideTopBorders(i),
                'MobileActionsModal__Link--TopBorder': i > 0,
              }"
              [attr.aria-label]="action.label"
              [innerHTML]="action.label"
            ></div>
          </ds-link>
        }
      </div>
      <zip-button
        class="MobileActionsModal__Button"
        (click)="cancel()"
        [config]="buttonsConfig"
      ></zip-button>
    </div>
  </div>
}
